import axios from 'axios';

/**
 * This used to have a cache layer in here. It's been temporarily removed because we were having weird issues and we
 * wanted to eliminate this as the cause.
 * @param url
 * @param options
 * @returns {Promise<void>}
 */
const dataFetch = async function(url, options = {} /*, cacheMaxAge*/) {
  const res = await axios.get(url, options);
  return res.data;
};

export { dataFetch };
